/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <HeroCarousel {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { HeroCarousel as HeroCarouselModule } from "@bw/modules"

const HeroCarousel = ({ slides, fullPage }) => {
  return <HeroCarouselModule slides={slides} fullPage={fullPage} />
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on HeroCarouselModule {
 *   ...HeroCarouselModuleFragment
 * }
 *
 * This is also what you will get in the props of your HeroCarousel
 * resolver component.
 */
export const query = graphql`
  fragment HeroCarouselModuleFragment on HeroCarouselModule {
    slides {
      suptitle
      title
      subtitle
      buttons {
        isExternal
        openInModal
        linkType {
          value
        }
        url
        linkText
        entry {
          url
        }
      }
      image {
        alt
        has_focus
        focus_css
        localImage {
          childImageSharp {
            gatsbyImageData(width: 2500)
          }
        }
      }
    }
    fullPage
  }
`

export { HeroCarousel }
